import { Stack } from '@mui/joy'
import { useTranslation } from 'react-i18next'
import { Alert } from '~/shared/ui/Alerts'
import { Button } from '~/shared/ui/Buttons'
import { Modal } from '~/shared/ui/Modal'

type ContinueModalProps = {
  isShow: boolean
  onOk: () => Promise<void>
  onCancel: () => void
  isSubmitting: boolean
}

export const ContinueModal = ({
  isShow,
  onOk,
  onCancel,
  isSubmitting,
}: ContinueModalProps) => {
  const { t } = useTranslation()

  return (
    <Modal
      isShow={isShow}
      onCancel={isSubmitting ? undefined : onCancel}
      dialogProps={{
        sx: {
          minWidth: '500px',
          maxWidth: '500px',
        },
      }}
    >
      <Alert variant='info' sx={{ margin: '44px 0 24px 0' }}>
        {t('button.resume the contract')} ?
      </Alert>

      <Stack direction='row' justifyContent='space-between' spacing={2}>
        <Button
          variant='gray'
          fullWidth
          onClick={onCancel}
          disabled={isSubmitting}
        >
          {t('button.cancel')}
        </Button>
        <Button variant='brand' fullWidth onClick={onOk} loading={isSubmitting}>
          {t('button.resume')}
        </Button>
      </Stack>
    </Modal>
  )
}
